export default __webpack_public_path__ + "static/media/home-2.6a49066c.png";